import { render, staticRenderFns } from "./AddressDetailable.vue?vue&type=template&id=c0a2625c&scoped=true&"
import script from "./AddressDetailable.vue?vue&type=script&lang=js&"
export * from "./AddressDetailable.vue?vue&type=script&lang=js&"
import style0 from "./AddressDetailable.vue?vue&type=style&index=0&id=c0a2625c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0a2625c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VChip,VIcon,VMenu})
